<ng-container *ngIf="getValidationError() as errorMessage">
    <mat-icon>warning</mat-icon> {{errorMessage}}
</ng-container>
<ng-content *ngIf="!getValidationError()"></ng-content>
